import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';
import Logo from '../common/Logo';
import MenuSidebar from '../navigation/MenuSidebar';
import { navbar } from '../../utils/animations';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMenuOpen]);

  return (
    <>
      <motion.nav
        className="fixed top-0 left-0 right-0 z-30 bg-navy-900 px-4 py-0.5 transition-all duration-300"
        variants={navbar}
        initial="hidden"
        animate="visible"
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            {/* Hamburger MenU Button */}
            <motion.button
              onClick={() => setIsMenuOpen(true)}
              className="p-2 rounded-lg text-white hover:bg-brown-600 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Open menu"
            >
              <Menu size={28} />
            </motion.button>

            {/* Centered Logo with Navy Background */}
            <div className="flex-1 flex justify-center">
              <div className="bg-navy-900 px-4 py-1 rounded-lg">
                <Logo
                  size="large"
                  className="opacity-100"
                />
              </div>
            </div>

            {/* Right Space (for balance) */}
            <div className="w-12"></div>
          </div>
        </div>
      </motion.nav>

      {/* Menu Sidebar */}
      <MenuSidebar isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default Navbar;
